import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { BrandStory } from "./components/BrandStory";
import { DiningModel } from "./components/DiningModel";
import { PricingTiers } from "./components/PricingTiers";
import { BoardingTeaser } from "./components/BoardingTeaser";
import { Footer } from "./components/Footer";
import { Toaster } from "sonner";
import SupportPage from "./pages/SupportPage";

const Landing = () => {
  return (
    <div data-testid="landing-root" className="bg-[#f9f6f0] text-[#2c1e16] min-h-screen">
      <Header />
      <main>
        <Hero />
        <BrandStory />
        <DiningModel />
        <PricingTiers />
        <BoardingTeaser />
      </main>
      <Footer />
      <Toaster position="bottom-center" />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/support" element={<SupportPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
